import { render, staticRenderFns } from "./SatelliteDatalog.vue?vue&type=template&id=2e0a877f&scoped=true"
import script from "./SatelliteDatalog.vue?vue&type=script&lang=js"
export * from "./SatelliteDatalog.vue?vue&type=script&lang=js"
import style0 from "./SatelliteDatalog.vue?vue&type=style&index=0&id=2e0a877f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0a877f",
  null
  
)

export default component.exports